/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import useRouterSearchParams from "hooks/useRouterSearchParams";
import SearchInputWithClickableIcon from "components/common/SearchInputwithClickableIcon";
import { URL_KEYS } from "constants/dashboard";

export default function SearchOnEnterInput({ className, paramKey = URL_KEYS.search }) {
  const [searchParams, setSearchParams] = useRouterSearchParams();
  const [localValue, setLocalValue] = useState(searchParams.get(paramKey) || "");

  const urlParamValue = searchParams.get(paramKey) || "";

  useEffect(() => {
    setLocalValue(urlParamValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlParamValue]);

  const handleSearch = () => {
    const newParams = new URLSearchParams(searchParams);
    if (localValue) {
      newParams.set(paramKey, localValue);
    } else {
      newParams.delete(paramKey);
    }
    newParams.set(URL_KEYS.page, "0");
    setSearchParams(newParams);
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    if (!newValue) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete(paramKey);
      newParams.set(URL_KEYS.page, "0");
      setSearchParams(newParams);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const placeholder =
    paramKey === URL_KEYS.search ? "Search..." : "Search for keywords in email thread...";
  return (
    <SearchInputWithClickableIcon
      className={className}
      value={localValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onIconClick={handleSearch}
      placeholder={placeholder}
    />
  );
}

SearchOnEnterInput.propTypes = {
  className: PropTypes.string,
  paramKey: PropTypes.string,
};
